import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import { NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useEffect, useRef, useState } from 'react';
// import { parse } from 'node-html-parser';
import parse from 'html-react-parser';
import { useRouter } from 'next/router';
import {
  DATALAYER_TYPE,
  sendDataLayerGlobal
} from 'src/utils/datalayer/send-datalayer';
// import { useFetch } from 'services/useFetch';
import { FaEye, FaRegCalendarAlt, FaUser } from 'react-icons/fa';
import CardV from 'src/components/cards/card-v';
import EmptyArticle from 'src/components/empty';
import Layout from 'src/components/layouts';
import WidgetSocialShare from 'src/components/widgets/widget-social-share';
import {
  APP_IMG,
  APP_URL,
  IS_NO_ROBOT_INDEX,
  // IS_SHOW_COOKIE,
  LAST_ARTICLE_ID,
  NEXT_DEFAULT_COUNT_VIEW,
  NEXT_PUBLIC_SPEED_KEYPOINT,
  SHOW_COMMEMORATE
} from 'src/constants';
import {
  IMAGE_DEFAULT,
  LOGO_192,
  WEB_DESC,
  WEB_KEYWORD,
  WEB_NAME,
  WEB_URL
} from 'src/constants/layout';
// import WidgetCookie from 'src/components/widgets/widget-cookie';

import {
  arrayEmpty,
  convertObjPath,
  escapeChar,
  htmlToPlainText,
  rewriteTxt,
  timestamp,
  useDateUpdate,
  useDesktop,
  usePageViews
} from 'src/utils/helper';

import { KEY_ADS_POSITION } from 'src/components/ads/dynamic-ads';
import { KEY_HEADING_TAG } from 'src/components/heading/heading-tag';
import WidgetFollowUs from 'src/components/widgets/widget-follow-us';
import {
  getAffiliate,
  getFeatureImage
  // useImageCaption
  // setImages,
} from 'src/utils/contents';
import { getCountviews } from 'src/utils/countview';
// import { getSizeIframe } from 'src/utils/contents/size-iframe';
import { useMediaQuery } from 'react-responsive';
import Carousels from 'src/components/carousels';
import WidgetGallery from 'src/components/gallery/widget-gallery';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
import { setContents } from 'src/utils/contents/set-contents';
import { isShouldFetch } from 'src/utils/detect-scrolling';
import { GET, GET_ARTICLES } from 'src/utils/services';
import useUser from 'src/utils/useUser';
import styled from 'styled-components';
// import WidgetStickyContents from 'src/components/widgets/translates/widget-sticky-contents';

const HeadingTag = dynamic(import('src/components/heading/heading-tag'), {
  ssr: false
});
const StickyBox = dynamic(import('react-sticky-box'), { ssr: false });
const DynamicAds = dynamic(import('src/components/ads/dynamic-ads'), {
  ssr: true
});
const SectionAffiliate = dynamic(
  import('src/components/sections/section-event/section-affiliate')
);
const AdsNative = dynamic(import('src/components/ads/ads-native'), {
  ssr: true
});

const PageDetail = ({
  article,
  related,
  lastNews,
  solrRelated,
  dataAdsNative,
  dataAffiliate,
  dataAdsHeader,
  ads,
  agent
}) => {
  const _data = useUser();
  const sessionSevId = _data?.user ? decryptionClient(_data?.user) : null;
  if (!article) return <EmptyArticle sessionSevId={sessionSevId} />;

  // const [isTranslate, setIsTranslate] = useState(false);
  const [isKeyPoint, setIsKeyPoint] = useState(true);
  const [closeAd, setCloseBoxAd] = useState(true);

  const handleCloseBoxAd = () => {
    setCloseBoxAd(false);
  };
  // const [isLoading, setIsLoading] = useState(false);
  // const [selectLang, setSelectLang] = useState('TH');
  // const [newsArticle, setNewsArticle] = useState({ ...article });
  useEffect(() => {
    if (!NEXT_PUBLIC_SPEED_KEYPOINT) {
      return; // ออกจาก useEffect ถ้าไม่มีค่า speed
    }
    setIsKeyPoint(true);
    const keypointContent = document.getElementById('keypoint-content');
    // ป้องกัน CLS: ล็อกความสูงเดิม (จาก SSR) ไว้ก่อนล้างเนื้อหาแล้วพิมพ์ใหม่
    // ไม่งั้นกล่องจะยุบ -> ค่อย ๆ โตตามตัวอักษร ทำให้เนื้อหาด้านล่างเลื่อน
    if (keypointContent) {
      keypointContent.style.minHeight = `${keypointContent.offsetHeight}px`;
    }
    while (keypointContent?.firstChild) {
      keypointContent?.removeChild(keypointContent?.firstChild);
    }
    if (isKeyPoint === true && !isEmpty(article?.key_point)) {
      const element = document.getElementById('scrollto');
      element?.scrollIntoView({ behavior: 'smooth', block: 'center' });

      const div = document.createElement('div');
      div.innerHTML = article?.key_point || '';

      const strongElements = div.getElementsByTagName('strong');
      for (let i = 0; i < strongElements.length; i++) {
        strongElements[i].style.fontWeight = 'bold';
      }

      const speed = Number(NEXT_PUBLIC_SPEED_KEYPOINT) ?? 50;

      let txt = article?.key_point;
      let i = 0;

      txt = htmlToPlainText(txt?.replace(/<\/?[^>]+(>|$)/g, (match) => (match === '<li>' ? '_' : match === '<p>' ? '#' : '')));

      let ul = document.createElement('ul');
      let li = document.createElement('li');
      let divP = document.createElement('div');
      let currentMode = 'paragraph';

      const intervalId = setInterval(() => {
        if (i < txt.length) {
          const char = txt.charAt(i);

          if (char === '#') {
            // เพิ่ม p เก่าเข้า DOM ในตำแหน่งปัจจุบัน
            if (divP && divP.innerHTML.trim() !== '') {
              keypointContent?.appendChild(divP);
            }

            // สร้าง p ใหม่
            divP = document.createElement('p');
            currentMode = 'paragraph';

            i++;
          } else if (char === '_') {
            // เพิ่ม p ปัจจุบันก่อน (ถ้าเปลี่ยนจาก paragraph เป็น list)
            if (currentMode === 'paragraph' && divP && divP.innerHTML.trim() !== '') {
              keypointContent?.appendChild(divP);
              divP = null;
            }

            // สร้าง ul ใหม่เฉพาะเมื่อยังไม่มี หรือเพิ่งออกจาก paragraph mode
            if (currentMode !== 'list') {
              ul = document.createElement('ul');
              keypointContent?.appendChild(ul);
            }

            // สร้าง li ใหม่เสมอ
            li = document.createElement('li');
            ul.appendChild(li);
            currentMode = 'list';

            i++;
          } else {
            if (currentMode === 'list' && li) {
              li.innerHTML += char;
            } else if (currentMode === 'paragraph' && divP) {
              divP.innerHTML += char;

              // เพิ่ม p เข้า DOM ครั้งแรกที่มีข้อความ
              if (divP.innerHTML.length === 1 && !divP.parentNode) {
                keypointContent?.appendChild(divP);
              }
            }

            i++;
          }
        } else {
          // เมื่อจบ loop
          if (divP && divP.innerHTML.trim() !== '' && !divP.parentNode) {
            keypointContent?.appendChild(divP);
          }

          clearInterval(intervalId);
        }
      }, speed);

      return () => clearInterval(intervalId);
    }
  }, [isKeyPoint]);

  // const handleTranslate = async (newLanguage) => {
  //   try {
  //     setSelectLang(newLanguage);
  //     setIsLoading(true);
  //     setIsTranslate(!isTranslate);
  //     setIsKeyPoint(false);
  //     if (NEXT_PUBLIC_URL_SOUND !== undefined || !isEmpty(article?.id)) {
  //       const uriToken = `${NEXT_PUBLIC_URL_SOUND}/create`;
  //       const getToken = await axios
  //         .post(
  //           uriToken,
  //           {
  //             app: 'default'
  //           },
  //           {
  //             headers: {
  //               'Content-Type': 'application/json',
  //               'User-Agents': `NationSpeech/1.0 ${agent}`
  //             }
  //           }
  //         )
  //         .catch(error => {
  //           console.error(error);
  //         });

  //       // console.log({ getToken });
  //       if (getToken?.data?.data?.token !== undefined) {
  //         const uriEn = `${NEXT_PUBLIC_URL_SOUND}/translates/${article?.id}/${newLanguage}`;
  //         // console.log('uriEn', uriEn);

  //         const translate = await axios
  //           .post(
  //             uriEn,
  //             {
  //               data: {
  //                 id: article?.id,
  //                 site: NEXT_PUBLIC_WEB_NAME_SOUND,
  //                 language: newLanguage
  //               }
  //             },
  //             {
  //               headers: {
  //                 'Content-Type': 'application/json',
  //                 'User-Agents': `NationSpeech/1.0 ${agent}`,
  //                 accessToken: getToken?.data?.data?.token,
  //                 accessTimeStamp: getToken?.data?.data?.timestamp
  //               }
  //             }
  //           )
  //           .catch(error => {
  //             console.error(error);
  //           });
  //         await new Promise(resolve => setTimeout(resolve, 500));
  //         setNewsArticle({
  //           ...article,
  //           ...translate?.data?.data
  //         });
  //       }
  //     }
  //   } catch (error) {
  //     setIsLoading(true);
  //     console.log(error, 'Error Translate ');
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  const _article = {
    ...article,
    // ...newsArticle,
    description: article?.meta?.description || WEB_DESC,
    keyword: article?.meta?.keyword || WEB_KEYWORD,
    image_url: article?.meta?.og_social_image || IMAGE_DEFAULT
  };
  const router = useRouter();
  const [updateCountView, setUpdateCountView] = useState(0);
  const dateUpdate = useDateUpdate(_article?.published_at);
  // const countViewUpdate = updateCountView;
  const baseUrlCategory = `${APP_URL}${_article?.link}`;

  /* ----------------------------------- SEO ---------------------------------- */
  const articleTitleSeo = escapeChar(_article?.title);
  const articleDescriptionSeo = escapeChar(_article?.description);
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    /* ------------------------------ GET COUNTVIEW ----------------------------- */
    (async () => {
      try {
        const _countviews = await getCountviews(_article?.id);
        if (_countviews) {
          setUpdateCountView(_countviews + Number(_article?.pageviews));
        }
      } catch (error) {
        setUpdateCountView(0);
      }
    })();
    /* ---------------------------- SET IMAGE_CAPTION --------------------------- */
    // useImageCaption('contents');
    // -------------------------------- SET IFRAME --------------------------------
    // getSizeIframe('contents');
    // -------------------------------- SET IMAGES --------------------------------
    // setImages('contents');
    setContents();
  }, []);

  // ACCEPT COOKIE ********************************
  const handleScrollAdsPostArticle = () => {
    const sectionEl = document.getElementById('cookie');
    const sticky = document.querySelector('.sticky-cookie');
    // const cookies = document.querySelector('.displayC');
    if (sectionEl !== null) {
      if (sectionEl.offsetTop < document.documentElement.scrollTop + 300) {
        if (sticky) {
          sticky.style.display = 'block';
        }
        // if (IS_SHOW_COOKIE === 'true') {
        //   cookies.style.display = 'none';
        // }
      } else {
        if (sticky) {
          sticky.style.display = 'none';
        }
        // if (IS_SHOW_COOKIE === 'true') {
        //   cookies.style.display = 'unset';
        // }
      }
    }
  };

  useEffect(() => {
    document.addEventListener('scroll', handleScrollAdsPostArticle, { passive: true });
    return () => document.removeEventListener('scroll', handleScrollAdsPostArticle);
  }, []);

  /* -------------------------------- DATALAYER ------------------------------- */

  const nextSectionIndexRef = useRef(0);
  const sectionsVisibleRef = useRef([]);
  const sectionRef = useRef(null);
  const footerRef = useRef(false);
  const loadMoreArticles = () => {
    try {
      if (nextSectionIndexRef?.current < related.length) {
        if (isShouldFetch()) {
          const currentIndex = nextSectionIndexRef.current;
          const section = related[currentIndex];

          nextSectionIndexRef.current = currentIndex + 1;
          sectionsVisibleRef.current = [...sectionsVisibleRef.current, section];

          setTimeout(() => {
            loadMoreArticles();
          }, 1000);
        } else {
          document.addEventListener('scroll', handleScroll);
        }
      }
    } catch (err) {
      console.error(
        `${timestamp()}==========> INDEX ERROR : ${nextSectionIndexRef.current
        }`,
        err
      );
    }
  };

  const handleParagraphOne = async () => {
    const sectionEl = await document.getElementById('paragraph-1');

    if (sectionEl) {
      if (sectionEl.offsetTop < document.documentElement.scrollTop) {
        sectionRef.current = 'paragraph-1';

        document.removeEventListener('scroll', handleParagraphOne);
        await sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_SCROLL,
          router: router?.pathname,
          section: 'scroll',
          data: {
            title: router.asPath,
            heading: 'paragraph-1'
          }
        });
      }
    }
  };

  const handleParagraphTwo = async () => {
    const sectionEl = await document.getElementById('paragraph-2');

    if (sectionEl) {
      if (sectionEl.offsetTop < document.documentElement.scrollTop) {
        sectionRef.current = 'paragraph-2';
        document.removeEventListener('scroll', handleParagraphTwo);
        await sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_SCROLL,
          router: router?.pathname,
          section: 'scroll',
          data: {
            title: router.asPath,
            heading: 'paragraph-2'
          }
        });
      }
    }
  };

  const handleParagraphThree = async () => {
    const sectionEl = await document.getElementById('paragraph-3');
    if (sectionEl) {
      if (sectionEl.offsetTop < document.documentElement.scrollTop) {
        sectionRef.current = 'paragraph-3';
        document.removeEventListener('scroll', handleParagraphThree);
        await sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_SCROLL,
          router: router?.pathname,
          section: 'scroll',
          data: {
            title: router.asPath,
            heading: 'paragraph-3'
          }
        });
      }
    }
  };
  const handleScrollToReadComplete = async () => {
    try {
      const sectionEl = await document.getElementById('section-ads');
      if (sectionEl !== null) {
        if (sectionEl.offsetTop < document.documentElement.scrollTop) {
          // console.log(sectionEl);
          // console.log(localStorage.getItem('_t'), isNaN(localStorage.getItem('_t')));
          sectionRef.current = 'section-ads';
          const _t = localStorage.getItem('_t');
          if (!isNaN(_t)) {
            const counter = parseInt(_t);
            const toArray = (num) =>
              num && [...`${num}`].map((elem) => parseInt(elem));
            const _a =
              toArray(counter)[toArray(counter).length - 1] === 0 ? 0 : 1;
            const _b = counter - 1;
            const start = Math.floor((_a === 0 ? _b : counter) / 10) * 10;
            const end = Math.ceil(counter / 10) * 10;
            const first = start === 0 ? 1 : start + 1;
            const second = end === 0 ? 10 : end;
            const timer = `${first}-${second}`;

            document.removeEventListener('scroll', handleScrollToReadComplete);
            await sendDataLayerGlobal({
              type: DATALAYER_TYPE.TRACK_READTIME,
              router: router?.pathname,
              section: 'scroll',
              data: {
                title: router.asPath,
                heading: 'read-complete',
                time: timer
              }
            });
            await localStorage.removeItem('_t');
          } else {
            document.removeEventListener('scroll', handleScrollToReadComplete);
            await sendDataLayerGlobal({
              type: DATALAYER_TYPE.TRACK_READTIME,
              router: router?.pathname,
              section: 'scroll',
              data: {
                title: router.asPath,
                heading: 'read-complete',
                time: '1-10'
              }
            });
            await localStorage.removeItem('_t');
          }
        }
      }
    } catch (err) {
      console.error(
        `${timestamp()} ==========> handleScrollToReadComplete ERROR`
      );
    } finally {
      footerRef.current = true;
    }
  };
  const handleScrollToSectionFooter = async () => {
    const sectionEl = await document.getElementById('footer-wrapper');
    if (footerRef.current) {
      if (sectionEl?.offsetTop < document.documentElement.scrollTop + 500) {
        document.removeEventListener('scroll', handleScrollToSectionFooter);
        await sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_SCROLL,
          router: router?.pathname,
          section: 'scroll',
          data: {
            title: router.asPath,
            heading: 'footer-wrapper'
          }
        });
      }
    }
  };
  useEffect(() => {
    let intervalId;
    try {
      localStorage.setItem('_t', '0');
      intervalId = setInterval(() => {
        const time = parseInt(localStorage.getItem('_t') || '0');
        localStorage.setItem('_t', time + 1);
      }, 1000);
    } catch (err) {
      console.log('Error: Please enable website cookies. ' + err);
    }
    return () => clearInterval(intervalId);
  }, []);

  const handleScroll = () => {
    if (isShouldFetch()) {
      document.removeEventListener('scroll', handleScroll);
      loadMoreArticles();
    }
  };

  useEffect(() => {
    document.addEventListener('scroll', handleScroll, { passive: true });
    return () => document.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleParagraphOne, { passive: true });
    return () => document.removeEventListener('scroll', handleParagraphOne);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleParagraphTwo, { passive: true });
    return () => document.removeEventListener('scroll', handleParagraphTwo);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleParagraphThree, { passive: true });
    return () => document.removeEventListener('scroll', handleParagraphThree);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleScrollToReadComplete, { passive: true });
    return () =>
      document.removeEventListener('scroll', handleScrollToReadComplete);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleScrollToSectionFooter, { passive: true });
    return () =>
      document.removeEventListener('scroll', handleScrollToSectionFooter);
  }, []);
  // handleCommemorate
  // function getScrollTop () {
  //   if (typeof window.pageYOffset !== 'undefined') {
  //     // Most browsers
  //     return window.pageYOffset;
  //   }

  //   const d = document.documentElement;
  //   if (typeof d.clientHeight !== 'undefined') {
  //     // IE in standards mode
  //     return d.scrollTop;
  //   }

  //   // IE in quirks mode
  //   return document.body.scrollTop;
  // }
  const isMb = useMediaQuery({ query: '(max-width: 768px)' });
  useEffect(() => {
    if (!isMb) return;

    const handleWidgetScroll = () => {
      // ✅ requestAnimationFrame — ไม่ block main thread
      requestAnimationFrame(() => {
        const box = document.getElementById('widget-group-js');
        if (!box) return;
        const scroll = window.scrollY; // ✅ ไม่ต้องใช้ getScrollTop()
        box.style.top = `${scroll <= 0 ? 150 : 150 + scroll + 2}px`;
      });
    };

    // ✅ passive: true — บอก browser ว่าไม่มี preventDefault
    window.addEventListener('scroll', handleWidgetScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleWidgetScroll);
  }, [isMb]);
  // handleCommemorate
  // ***********************************************************************
  return (
    <>
      {/* -------------------------------- NEXT_SEO -------------------------------- */}
      <NextSeo
        noindex={IS_NO_ROBOT_INDEX}
        nofollow={IS_NO_ROBOT_INDEX}
        title={_article?.title}
        description={_article?.description}
        openGraph={{
          type: 'article',
          locale: 'th_TH',
          site_name: WEB_NAME,
          title: _article?.title,
          description: _article?.description,
          url: baseUrlCategory,
          article: {
            publishedTime: _article?.published_at,
            modifiedTime: _article?.updated_at,
            expirationTime: null,
            section: _article?.section?.th,
            authors: [`${WEB_URL.FACEBOOK}`],
            tags: _article?.tags
          },
          images: [
            {
              url: _article?.image_url,
              width: '700',
              height: '395',
              alt: _article?.title
            }
          ]
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: _article?.keyword
          }
        ]}
      />
      {/* --------------------------------- HEADER --------------------------------- */}
      <Head>
        <link rel='canonical' href={`${_article?.canonical}`} />
        {/* ---- PERF: preload LCP feature image (skip when feature is a video) ---- */}
        {_article?.image && !['0', '1', '2'].includes(_article?.type_video) && (
          <link
            rel='preload'
            as='image'
            href={`${APP_IMG}${_article?.image}?x-image-process=style/LG-webp`}
            type='image/webp'
            fetchpriority='high'
          />
        )}
        <meta property='twitter:title' content={_article?.title} />
        <meta property='twitter:description' content={_article?.description} />
        <meta
          property='twitter:image'
          content={_article?.image_url || IMAGE_DEFAULT}
        />

        {/* ------------------------------- Truehit -------------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `
                __th_page="${_article?.section?.en}";
              `
          }}
        />

        {/* ---------------------------- SNIPPET : WebSite --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
                {
                  "@context": "https://schema.org",
                  "@type": "WebSite",
                  "name": "${WEB_NAME}",
                  "url": "${WEB_URL.WEB}",
                  "description": "${articleDescriptionSeo}",
                  "sameAs": [
                    "${WEB_URL.FACEBOOK}",
                    "${WEB_URL.TWITTER}",
                    "${WEB_URL.YOUTUBE}",
                    "${WEB_URL.LINE}",
                    "${WEB_URL.INSTAGRAM}"
                  ],
                  "potentialAction": {
                    "@type": "SearchAction",
                    "target": "${WEB_URL.WEB}search?q={search_term_string}",
                    "query-input": "required name=search_term_string"
                  }
                }
              `
          }}
        />

        {/* ---------------------------- SNIPPET : WebPage --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: ` 
                { 
                  "@context": "http://schema.org", 
                  "@type": "WebPage", 
                  "name": "${articleTitleSeo}", 
                  "description": "${articleDescriptionSeo}", 
                  "publisher": { 
                    "@type": "ProfilePage", 
                    "name": "${WEB_NAME}" 
                  } 
                } 
              `
          }}
        />

        {/* ------------------------ SNIPPET : BreadcrumbList ------------------------ */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: ` 
                { 
                  "@context": "http://schema.org", 
                  "@type": "BreadcrumbList", 
                  "itemListElement": [ 
                    { 
                      "@type": "ListItem", 
                      "position": 1, 
                      "name": "หน้าแรก", 
                      "item": "${APP_URL}" 
                    }, 
                    { 
                      "@type": "ListItem", 
                      "position": 2, 
                      "name": "${_article?.section?.th}", 
                      "item": "${APP_URL}/${_article?.section?.en}" 
                    }, 
                    { 
                      "@type": "ListItem", 
                      "position": 3, 
                      "name": "${articleTitleSeo}", 
                      "item": "${_article?.canonical || `${APP_URL}${_article?.link}`
              }"
                    } 
                  ] 
                } 
              `
          }}
        />

        {/* -------------------------- SNIPPET : NewsArticle ------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: ` 
                { 
                  "@context": "http://schema.org", 
                  "@type": "NewsArticle", 
                  "mainEntityOfPage": { 
                    "@type": "WebPage", 
                    "@id": "${_article?.canonical || `${APP_URL}${_article?.link}`
              }"
                  }, 
                  "headline": "${articleTitleSeo}", 
                  "alternativeHeadline": "${articleTitleSeo}", 
                  "description": "${articleDescriptionSeo}", 
                  "image": "${APP_IMG}${_article?.image}", 
                  "datePublished": "${_article?.published_at}",
                  "dateModified": "${_article?.updated_at}",
                  "author": { 
                    "@type": "Thing", 
                    "name": "${WEB_NAME}",
                    "url": "${APP_URL}"
                  }, 
                  "publisher": { 
                    "@type": "Organization", 
                    "name": "${WEB_NAME}", 
                    "logo": { 
                      "@type": "ImageObject", 
                      "url": "${APP_IMG}/static/${LOGO_192}" 
                    } 
                  } 
                } 
              `
          }}
        />

        {/* --------------------------- Social embed script -------------------------- */}
        <script async src='//www.instagram.com/embed.js' />
        <script async src='https://www.tiktok.com/embed.js' />
        {/* <script async src='https://platform.twitter.com/widgets.js' /> */}

        {/* {article.is_show_ads && parse(dataAdsNative?.header)} */}
        {/* { _article.is_show_ads && <script type='text/javascript' src='https://jsc.mgid.com/t/h/thainewsonline.co.1115175.js' async /> } */}

        {/* MGID */}
        {/* <script src='https://jsc.mgid.com/t/n/tnews.co.th.986049.js' async></script> */}
        {/* -------------------------------- ADS : PPN ------------------------------- */}
        {!useDesktop() && !isEmpty(dataAdsHeader)
          ? parse(`${dataAdsHeader?.header_mobile}`)
          : ''}
        {useDesktop() && !isEmpty(dataAdsHeader)
          ? parse(`${dataAdsHeader?.header_desktop}`)
          : ''}

        {/* <script async type='text/javascript' src='https://securepubads.g.doubleclick.net/tag/js/gpt.js' />
        <script type='text/javascript' dangerouslySetInnerHTML={{
          __html: 'var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];'
        }} /> */}
      </Head>
      {!isEmpty(dataAffiliate) && (
        <SectionAffiliate position={4} data={dataAffiliate} />
      )}

      <Layout ads={ads} sessionSevId={sessionSevId}>
        {/* -------------------------- ADS-PPN : Billboard ------------------------------ */}
        {/* <div className='overflow-hidden default-billboard'> */}
        {/* </div> */}
        {/* ------------------------------ MAIN : START ------------------------------ */}
        <div
          className={`detail-wrapper ${SHOW_COMMEMORATE === 'true' ? 'commemorate-mode' : ''}`}
        >
          <AdsWrapper isShowAds={!!_article?.is_show_ads}>
            {_article?.is_show_ads && (
              <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />
            )}
          </AdsWrapper>
          <div className='container readpage' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.5)' : 'unset' }} >
            {/* ----------------------------------- CONTENTS : Start ---------------------------------- */}
            <div className='article-area'>
              <div className='row'>
                <div className='col-12 col-lg-8'>
                  {/* ------------------------------ HEADING : START ----------------------------- */}
                  <div className={`breadcrumb-area ${!isEmpty(ads) ? 'is-ads' : ''}`} >
                    <div className='breadcrumb-title'>
                      <div className='badge'>
                        <a
                          href={
                            _article.subCategory?.th
                              ? `/category/${_article?.section?.en}/${_article?.subCategory?.en}`
                              : `/category/${_article?.section?.en}`
                          }
                        >
                          <span>
                            {' '}
                            {_article.subCategory?.th
                              ? _article?.subCategory?.th
                              : _article?.section?.th}
                          </span>
                        </a>
                      </div>
                      <div className='category'> <h1 className='category'>{_article?.title}</h1></div>
                      <ul >
                        <li>
                          <a href='/'>หน้าแรก</a>
                        </li>
                        {_article.section?.th && (
                          <li>
                            <a href={`/category/${_article?.section?.en}`}>
                              {_article?.section?.th}
                            </a>
                          </li>
                        )}
                        {_article?.subCategory?.th && (
                          <li>
                            <a
                              href={`/category/${_article?.section?.en}/${_article?.subCategory?.en}`}
                            >
                              {_article?.subCategory?.th}
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                  {/* ------------------------------ HEADING : END ----------------------------- */}
                  <ImageWrapper className='content-feature-image '>
                    {getFeatureImage(_article)}
                  </ImageWrapper>
                  {/* <WidgetStickyContents className='block-sticky' isLoading={isLoading} article={article} handleTranslate={handleTranslate} selectLang={selectLang} router={router} /> */}
                  <div className='byline'>
                    {article?.byline && (
                      <span>
                        <FaUser /> By {article?.byline}
                      </span>
                    )}
                  </div>
                  <div id='contents' className='article-content'>
                    <div className='post-info'>
                      <ul className='dateUpdate'>
                        <li>
                          <FaRegCalendarAlt />
                          {dateUpdate}
                        </li>
                        {updateCountView > NEXT_DEFAULT_COUNT_VIEW
                          ? (
                            <li>
                              <FaEye />
                              {usePageViews(updateCountView)}
                            </li>
                            )
                          : null}
                      </ul>
                      <div className='justify-content-between align-items-center d-inline-flex'>
                        <span className='mx-2 d-none d-lg-flex'>แชร์ | </span>
                        <WidgetSocialShare
                          articleLink={article?.link}
                          //! DATALAYER
                          eventDataLayer={{
                            type: DATALAYER_TYPE.TRACK_POSITION,
                            router: router?.pathname,
                            section: 'แชร์ข่าว',
                            position: 'ใต้:header',
                            data: {
                              block: '1',
                              heading: 'แชร์ข่าว'
                            }
                          }}
                        />
                      </div>
                    </div>
                    {!isEmpty(_article?.key_point)
                      ? <div className='keypoint-wrapper'>
                        <HeadSeo
                          dangerouslySetInnerHTML={{
                            __html: `${_article?.blurb || ''}`
                          }}
                        />
                        <div className='keypoint-header'>
                          <p>KEY</p>
                          <p>POINTS</p>
                        </div>
                        <div
                          className='keypoint-lists'
                          id='keypoint-content'
                          dangerouslySetInnerHTML={{
                            __html: _article.key_point ?? ''
                          }}
                        />
                      </div>

                      : _article?.blurb && (
                        <>
                          <h2 className='content-blurb'>{_article.blurb}</h2>
                        </>
                      )}

                    <div id='paragraph'>
                      {/* ------------------------- CONTENTS I and ADS : INARTICLE 1 ------------------------- */}
                      {_article?.content_I && (
                        <div id='paragraph-1' className='default-inread'>
                          {_article?.is_show_ads && (
                            <DynamicAds
                              position={KEY_ADS_POSITION.INARTICLE_1}
                              data={ads}
                            />
                          )}

                          <div
                            className='content-detail'
                            dangerouslySetInnerHTML={{
                              __html: _article?.content_I
                            }}
                          />
                          {_article?.is_show_ads &&
                            getAffiliate(1, dataAffiliate)}
                        </div>
                      )}

                      {/* ------------------------- CONTENTS II and ADS : INARTICLE 2 ------------------------ */}
                      {_article?.content_II && (
                        <div id='paragraph-2' className='default-inread'>
                          {_article?.is_show_ads && (
                            <DynamicAds
                              position={KEY_ADS_POSITION.INARTICLE_2}
                              data={ads}
                            />
                          )}
                          <div
                            className='content-detail'
                            dangerouslySetInnerHTML={{
                              __html: _article?.content_II
                            }}
                          />
                          {_article?.is_show_ads &&
                            getAffiliate(2, dataAffiliate)}
                        </div>
                      )}

                      {/* -------------------------- CONTENTS III and ADS : INARTICLE 3 ----------------------- */}
                      {_article?.content_III && (
                        <div id='paragraph-3' className='default-inread'>
                          {_article?.is_show_ads && (
                            <DynamicAds
                              position={KEY_ADS_POSITION.INARTICLE_3}
                              data={ads}
                            />
                          )}
                          <div
                            className='content-detail'
                            dangerouslySetInnerHTML={{
                              __html: _article?.content_III
                            }}
                          />
                          {_article?.is_show_ads &&
                            getAffiliate(3, dataAffiliate)}
                        </div>
                      )}
                    </div>
                    <WidgetGallery
                      id={_article?.gallery_src?.split('/').pop() ?? '14'}
                      title={_article?.title}
                      article={_article}
                      data={_article?.gallery}
                      articleLink={_article?.link}
                      // ! DATALAYER
                      link={_article?.gallery_src ?? '/galleries/14'}
                      eventDataLayer={{
                        type: DATALAYER_TYPE.TRACK_POSITION,
                        router: router?.pathname,
                        section: 'อัลบั้มรูป',
                        position: 'ใต้:เนื้อหาที่ 3',
                        data: {
                          heading: 'อัลบั้มรูป'
                        }
                      }}
                    />
                    {/* { !isEmpty(related) &&
                    <WidgetNews
                      className='section--tag '
                      lastNews={related?.slice(0, 3)}
                      heading='ข่าวที่เกี่ยวข้อง'
                      // ! DATALAYER
                      eventDataLayer={{
                        type: DATALAYER_TYPE.TRACK_POSITION,
                        router: router.pathname,
                        section: 'ข่าวที่เกี่ยวข้อง',
                        position: 'เนื้อหาที่-3',
                        data: {
                          block: '1',
                          heading: 'ข่าวที่เกี่ยวข้อง'
                        }
                      }}
                    />} */}

                    {/* ------------------------------ READ_COMPLETE : TAGS - DESKTOP ------------------------ */}
                    <div className='content-tags d-none d-md-block'>
                      <span>Tags</span>
                      {!arrayEmpty(_article?.tags) &&
                        _article.tags.map((item, index) => (
                          <a
                            key={index}
                            href={`/tags/${item}`}
                            //! DATALAYER
                            onClick={() =>
                              sendDataLayerGlobal({
                                type: DATALAYER_TYPE.TRACK_POSITION,
                                router: router?.pathname,
                                section: 'แท็กที่เกี่ยวข้อง',
                                position: 'ใต้:ข่าวที่เกี่ยวข้อง',
                                data: {
                                  block: '1',
                                  title: item,
                                  heading: 'แท็กที่เกี่ยวข้อง',
                                  index: index + 1
                                }
                              })
                            }
                          >
                            {item}
                          </a>
                        ))}

                      <div className='section-sharelink --mobile'>
                        <div className='mt-4'>
                          <WidgetSocialShare
                            articleLink={article?.link}
                            //! DATALAYER
                            eventDataLayer={{
                              type: DATALAYER_TYPE.TRACK_POSITION,
                              router: router?.pathname,
                              section: 'แชร์ข่าว',
                              position: 'ใต้:แท็กที่เกี่ยวข้อง',
                              data: {
                                block: '1',
                                heading: 'แชร์ข่าว'
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='section-sharelink --mobile d-flex d-md-none'>
                      <div className='mt-4'>
                        <WidgetSocialShare
                          articleLink={article?.link}
                          //! DATALAYER
                          eventDataLayer={{
                            type: DATALAYER_TYPE.TRACK_POSITION,
                            router: router?.pathname,
                            section: 'แชร์ข่าว',
                            position: 'ใต้:แท็กที่เกี่ยวข้อง',
                            data: {
                              block: '1',
                              heading: 'แชร์ข่าว'
                            }
                          }}
                        />
                      </div>
                    </div>
                    {/* ------------------------------ READ_COMPLETE : TAGS - MOBILE ------------------------ */}
                    <div className='content-tags d-block d-md-none'>
                      <span>Tags</span>
                      {!arrayEmpty(_article?.tags) &&
                        _article.tags.map((item, index) => (
                          <a
                            key={index}
                            href={`/tags/${item}`}
                            //! DATALAYER
                            onClick={() =>
                              sendDataLayerGlobal({
                                type: DATALAYER_TYPE.TRACK_POSITION,
                                router: router?.pathname,
                                section: 'แท็กที่เกี่ยวข้อง',
                                position: 'ใต้:ข่าวที่เกี่ยวข้อง',
                                data: {
                                  block: '1',
                                  title: item,
                                  heading: 'แท็กที่เกี่ยวข้อง',
                                  index: index + 1
                                }
                              })
                            }
                          >
                            {item}
                          </a>
                        ))}
                    </div>
                    <div className='col-12 col-lg-12 block-readmore-content mt-4 wrapper-interest-news'>
                      <div className='section-title'>
                        <HeadingTag
                          title={'ข่าวที่เกี่ยวข้อง'}
                          type={KEY_HEADING_TAG.DETAIL}
                        />
                      </div>
                      {!isEmpty(related) && (
                        <Carousels slideShow={3} >
                          {related?.map((blockItem, index) => (
                            <CardV
                              key={index}
                              data={blockItem}
                              path={blockItem.link}
                              //! DATALAYER
                              eventDataLayer={{
                                type: DATALAYER_TYPE.TRACK_POSITION,
                                router: router?.pathname,
                                section: 'ข่าวที่เกี่ยวข้อง',
                                position: 'ใต้:แท็กที่เกี่ยวข้อง',
                                data: {
                                  title: blockItem?.title,
                                  block: '1',
                                  heading: 'ข่าวที่เกี่ยวข้อง',
                                  carousel: index + 1
                                }
                              }}
                            />
                          ))}
                        </Carousels>
                      )}
                    </div>
                    {/* {!arrayEmpty(solrRelated) && (
                      <div className='d-lg-none d-block mobile-solr-item mt-3'>
                        <Carousels>
                          {solrRelated.slice(0, 5).map((item, index) => (
                            <CardH
                              key={index}
                              data={item}
                              path={item.link}
                              external={true}
                              //! DATALAYER
                              eventDataLayer={{
                                type: DATALAYER_TYPE.TRACK_POSITION,
                                router: router?.pathname,
                                section: 'ข่าวที่เกี่ยวข้อง',
                                position: 'ใต้:แท็กที่เกี่ยวข้อง',
                                data: {
                                  title: item?.title,
                                  block: '1',
                                  heading: 'ข่าวที่เกี่ยวข้อง',
                                  carousel: index + 1
                                }
                              }}
                            />
                          ))}
                        </Carousels>
                      </div>
                    )} */}
                    {/* <div className='d-none d-lg-block col-12 col-lg-12 block-readmore-content mt-4 wrapper-interest-news'>
                      {!isEmpty(related) && (
                        <Carousels infinite={related.lenght > 3}>
                          {related?.map((blockItem, index) => (
                            <CardV
                              key={index}
                              data={blockItem}
                              path={blockItem.link}
                              //! DATALAYER
                              eventDataLayer={{
                                type: DATALAYER_TYPE.TRACK_POSITION,
                                router: router?.pathname,
                                section: 'ข่าวที่เกี่ยวข้อง',
                                position: 'ใต้:แชร์ข่าว',
                                data: {
                                  title: blockItem?.title,
                                  block: '1',
                                  heading: 'ข่าวที่เกี่ยวข้อง',
                                  carousel: index + 1
                                }
                              }}
                            />
                          ))}
                        </Carousels>
                      )}
                    </div> */}
                  </div>
                  {/* ------------------------ ADS : Postartice and Cookie ---------------------- */}
                  <div id='cookie' className='displayUnset'>
                    <div className='ads-postartice'>
                      {/* ----------------------------- ADS : POSTARTICE -------------------------- */}
                      {_article?.is_show_ads && (
            <div className={`close-box-ads ${!closeAd ? 'close' : 'open'}`}>
                <div onClick={handleCloseBoxAd} className='close-box'>
                  <DynamicAds position={KEY_ADS_POSITION.POSTARTICLE} data={ads} />
                </div>
            </div>
                      )}
                    </div>
                  </div>
                  <div className='col-12 block-readmore-content mt-5'>
                    {/* --------------------------- ADS : Native (Infinities) ----------------------------------- */}
                    {_article.is_show_ads && (
                      <AdsNative
                        data={dataAdsNative}
                        isShowAds={article?.is_show_ads}
                      />
                    )}
                  </div>
                </div>

                {/* ---------------------------- BLOCKSIDE : START --------------------------- */}
                <div className='col-12 col-lg-4 d-none d-lg-inline-block'>
                  <StickyBox offsetTop={80} offsetBottom={50}>
                    {/* -------------------------------- FOLLOW US ------------------------------- */}
                    <div className='mt-3 mb-7'>
                      <WidgetFollowUs />
                    </div>
                    {/* ----------------------------- ADS : STICKY-1 -------------------------- */}
                    <div className='default-sticky'>
                      {_article.is_show_ads && (
                        <DynamicAds
                          position={KEY_ADS_POSITION.STICKY_1}
                          data={ads}
                        />
                      )}
                    </div>
                    <div className='side-article'>
                      {lastNews?.length > 0 && (
                        <div className='mb-3'>
                          <div className='section-title'>
                            <HeadingTag
                              title={'ข่าวล่าสุด'}
                              type={KEY_HEADING_TAG.DETAIL}
                            />
                          </div>
                          <div className='row'>
                            {lastNews.slice(0, 4).map((item, index) => (
                              <div className='col-6' key={index}>
                                <CardV
                                  inContent={true}
                                  data={item}
                                  path={item?.link}
                                  //! DATALAYER
                                  eventDataLayer={{
                                    type: DATALAYER_TYPE.TRACK_POSITION,
                                    router: router?.pathname,
                                    section: 'ข่าวล่าสุด',
                                    position: 'ใต้:ติดตามเรา',
                                    data: {
                                      block: '2',
                                      title: item.title,
                                      heading: 'ข่าวล่าสุด',
                                      index: index + 1
                                    }
                                  }}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {/* ----------------------------- ADS : STICKY-2 -------------------------- */}
                      {_article.is_show_ads && (
                        <DynamicAds
                          position={KEY_ADS_POSITION.STICKY_2}
                          data={ads}
                        />
                      )}

                      {/* {!arrayEmpty(solrRelated) && (
                        <div className='mb-3'>
                          <div className='section-title'>
                            <HeadingTag
                              title={'ข่าวที่น่าสนใจ'}
                              type={KEY_HEADING_TAG.DETAIL}
                            />
                          </div>
                          <div className='row'>
                            {solrRelated.slice(0, 5).map((item, index) => (
                              <div key={index} className='col-12'>
                                <CardH
                                  external={true}
                                  data={item}
                                  path={item.link}
                                  //! DATALAYER
                                  eventDataLayer={{
                                    type: DATALAYER_TYPE.TRACK_POSITION,
                                    router: router?.pathname,
                                    section: 'ข่าวที่น่าสนใจ',
                                    position: 'ใต้:ข่าวล่าสุด',
                                    data: {
                                      block: '2',
                                      title: item.title,
                                      heading: 'ข่าวที่น่าสนใจ',
                                      index: index + 1
                                    }
                                  }}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )} */}
                    </div>
                  </StickyBox>
                  {/* ---------------------------- BLOCKSIDE : END --------------------------- */}
                </div>
              </div>
            </div>
            {/* ----------------------------------- CONTENTS : End ---------------------------------- */}
          </div>
        </div>
        {/* ------------------------------ MAIN : END ------------------------------ */}
      </Layout>
    </>
  );
};
const AdsWrapper = styled.div`
  min-height: ${({ isShowAds }) => isShowAds ? '300px' : '0'};
  transition: min-height 0.1s ease; /* smooth collapse */

  @media (max-width: 767px) {
    min-height: ${({ isShowAds }) => isShowAds ? '258px' : '0'};
  }
`;
const ImageWrapper = styled.div`
  margin-bottom: unset !important;
  aspect-ratio: 16 / 9;  
  width: 100%;
  overflow: hidden;
  background: #f0f0f0; 
`;
const HeadSeo = styled.h2`
  position: absolute;
  visibility: hidden;
  overflow: hidden;
`;
export async function getServerSideProps ({ req, res, params, query }) {
  const initProps = {
    statusCode: 200,
    errMessage: null,
    article: null,
    related: null,
    lastNews: null,
    solrRelated: [],
    lastArticleId: LAST_ARTICLE_ID || null,
    dataAffiliate: [],
    dataAdsNative: null,
    dataAdsHeader: null,
    ads: [],
    agent: null
  };

  const { expires, signature } = query;
  let preview = '';
  let previewParams = {};

  if (expires && signature) {
    preview = '/preview';
    previewParams = { expires, signature };
  }

  const url = req.url;

  // ✅ early return ก่อน fetch
  if (rewriteTxt(params.id) === 'latest-news') {
    return {
      redirect: {
        destination: `${APP_URL}/category/latest-news`,
        permanent: false
      }
    };
  }

  // ✅ URI logic สั้นลง
  let uri = `contents/${rewriteTxt(params.id)}`;
  const TYPED_PATHS = ['/advertorials', '/pr-news', '/blogs'];
  if (TYPED_PATHS.some(p => url.startsWith(p))) {
    uri = `contents/${params.id}/${query.type}`;
  }

  try {
    // ✅ Parallel fetch
    const [resData, adsHeaders] = await Promise.all([
      GET_ARTICLES(`/api/v1.0/${uri}${preview}${convertObjPath({ ...previewParams })}`, false, true),
      GET('/api/headerAds')
    ]);

    if (!isEmpty(adsHeaders)) {
      initProps.dataAdsHeader = adsHeaders;
    }

    if (resData?.statusCode === 404 || isUndefined(resData)) {
      res.setHeader('location', '/');
      res.statusCode = 301;
      res.end();
      return { props: initProps };
    }

    if (!isEmpty(resData?.data)) {
      initProps.article = resData?.data;
      initProps.related = resData?.related;
      initProps.lastNews = resData?.last_news;
      initProps.solrRelated = resData?.solrRelated ?? [];
      initProps.ads = resData?.ads ?? [];
      initProps.dataAffiliate = params.id > initProps.lastArticleId ? resData?.affiliate : [];
      initProps.dataAdsNative = resData?.adsNative || [];
      initProps.agent = req.headers['user-agent'];
    }

    // ✅ Cache HTML response — CDN/proxy เก็บ 1 นาที
    const isPreview = expires && signature;
    if (!isPreview) {
      res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate=300');
    }
  } catch (err) {
    console.log('==========> ARTICLE_DETAIL ERROR', err?.message);
    initProps.errMessage = err?.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return { props: initProps };
}

export default PageDetail;
